import { Box, Grid, Modal, Slider, Typography } from '@mui/material';
import { CalculateIcon, CloseIcon, Flex, IconButton, Button, Image, Input, Link, Text } from '@pancakeswap/uikit';
import Balance from 'components/Balance';
import React, { useState, FC, useEffect } from 'react';
import styled from 'styled-components';
import headerimage from '../../../../assets/images/headerimage.png'
import { ethers, BigNumber } from "ethers";
import { getLockUpAddress, getTokenAddress } from "utils/addressHelpers";
import { getContract } from "utils/contractHelpers";
import DrivenStakingABI from "ABI/DrivenStakingABI.json";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import { useWeb3React } from '@web3-react/core';
import metamask from "../../../../assets/images/metamask.svg"
import trustwallet from "../../../../assets/images/trustwallet.svg"
import binancechain from "../../../../assets/images/binancechain.svg"
import walletconnect from "../../../../assets/images/walletconnect.svg"
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { InjectedConnector } from "@web3-react/injected-connector";
import { BscConnector } from '@binance-chain/bsc-connector';
declare var window: any
const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    // border-bottom: 1px solid #00FED9;
    display: flex;
    padding: 24px 24px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ModalBody = styled(Box)`
    flex-direction: column;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    padding: 24px;
`

const chainID = "0x38";
const rpcUrl = "https://bsc-dataseed1.binance.org";
// const chainID = "0x61";
// const rpcUrl = "https://data-seed-prebsc-2-s1.binance.org:8545/";

const walletrpcConnectOption = new WalletConnectConnector({
    // rpc: { 97: `https://data-seed-prebsc-1-s1.binance.org:8545` },
    rpc: {
        56: rpcUrl,
        // 97: `https://data-seed-prebsc-1-s1.binance.org:8545`
    },
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
});
const Injected = new InjectedConnector({
    supportedChainIds: [56, 97]
});
const bscConnector = new BscConnector({
    supportedChainIds: [56, 97]
})

interface ConnectWalletProps {
    onClose: () => void;
    open: boolean;
}
const ConnectModal: React.FunctionComponent<ConnectWalletProps> = ({ open, onClose, }) => {

    const { error, connector, activate, deactivate, chainId, library, active, account } = useWeb3React();
    // const { account, connect } = bsc.useWallet()

    async function connect(walletType) {
        try {
            await deactivate();
            await switchNetwork();
            if (walletType === "metamask") {
                console.log("Connecting Metamsk");
                await activate(Injected);
                onClose();
            } else if (walletType === "binance") {
                await activate(bscConnector);
                onClose();
            }
            else if (walletType === "trustwallet") {
                await activate(Injected);
                onClose();
            }
        } catch (ex) {
            console.log(ex);
        }
    }
    async function walletConnectAccount() {
        try {
            await activate(walletrpcConnectOption);
            onClose();
        } catch (err) {
            console.log(err);
        }
    }
    const switchNetwork = async () => {
        try {
            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: chainID }],
            });
        } catch (switchError: any) {
            // 4902 error code indicates the chain is missing on the wallet
            if (switchError.code == 4902) {
                try {
                    await window.ethereum.request({
                        method: "wallet_addEthereumChain",
                        params: [
                            {
                                chainId: chainID,
                                chainName: "BSC Mainnet",
                                rpcUrls: [rpcUrl],
                                nativeCurrency: { name: "Binance", decimals: 18, symbol: "BNB" },
                                blockExplorerUrls: ["https://bscscan.com/"],
                                iconUrls: ["https://harmonynews.one/wp-content/uploads/2019/11/slfdjs.png"]
                            }
                        ],
                    });
                } catch (error) {
                    console.error(error)
                }
            }
        }
    };

    React.useEffect(() => {
        if (active)
            switchNetwork();
    }, [chainId])
    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                    }}>
                    <Box sx={{
                        width: 'auto',
                        // py: 4,
                        background: '#1A3342',
                        // boxShadow: 'rgba(14, 14, 44, 0.1) 0px 20px 36px -8px, rgba(0, 0, 0, 0.05) 0px 1px 1px',
                        borderRadius: '32px',
                        maxHeight: '100vh',
                        zIndex: '100',
                        minWidth: '346px'
                    }}>

                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>
                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        color: '#00FED9',
                                    }}>

                                    Connect Wallet
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>

                        <ModalBody>


                            <Flex alignItems="center" justifyContent="space-between" mb="8px">
                                <Grid container spacing={2}>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', py: 2 }} >
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => { connect("metamask") }} className="hover:opacity-75">
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                <img src={metamask} width="40"></img>
                                            </Box>
                                            <Text color="white" bold>Metamask</Text>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => { walletConnectAccount() }} className="hover:opacity-75">
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                <img src={walletconnect} width="40"></img>
                                            </Box>
                                            <Text color="white" bold>Wallet Connect</Text>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => { connect("metamask") }} className="hover:opacity-75">
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                <img src={trustwallet} width="40"></img>
                                            </Box>
                                            <Text color="white" bold>Trust Wallet</Text>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                        <Box sx={{ cursor: 'pointer' }} onClick={() => { connect("binance") }} className="hover:opacity-75">
                                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                <img src={binancechain} width="40"></img>
                                            </Box>
                                            <Text color="white" bold>Binance Chain</Text>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Flex>


                        </ModalBody>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}
export default ConnectModal;